import { Tooltip } from "@blueprintjs/core"
import { dateHelpers } from "@runn/calculations"
import { format as formatDate } from "date-fns"
import React, { Suspense } from "react"

import styles from "./PhaseItemTooltip.module.css"

import PhaseItemTooltipBudgetSection from "~/ProjectPlanner/Phases/PhaseItemTooltipBudgetSection"
import { RateCard } from "~/forms/ProjectBudgetForm/types"

type Props = {
  children: React.ReactElement
  projectId: number
  phase: {
    id: number
    name: string
    start_date: string
    end_date: string
    revenue_budget: number
  }
  rateCards: readonly RateCard[]
  usesPhaseBudget: boolean
  disabled?: boolean
}

const PhaseItemTooltip = (props: Props) => {
  const { phase, rateCards, usesPhaseBudget, children, disabled } = props

  return (
    <Tooltip
      content={
        <div>
          <div className={styles.phaseTooltipName}>
            <b>Name:</b> {phase.name}
          </div>
          <div>
            <b>Dates:</b>{" "}
            {formatDate(dateHelpers.parseRunnDate(phase.start_date), "dd MMM")}{" "}
            - {formatDate(dateHelpers.parseRunnDate(phase.end_date), "dd MMM")}
          </div>
          {usesPhaseBudget && (
            <Suspense fallback={null}>
              <PhaseItemTooltipBudgetSection
                projectId={props.projectId}
                phase={phase}
                rateCards={rateCards}
              />
            </Suspense>
          )}
        </div>
      }
      hoverOpenDelay={300}
      hoverCloseDelay={100}
      interactionKind="hover"
      disabled={disabled}
    >
      {children}
    </Tooltip>
  )
}

export default PhaseItemTooltip
